<template>
  <vxe-grid
    ref="vxeGrid"
    size="small"
    border
    resizable
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :header-cell-style="
      () => {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    "
  />
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('goods_label_orderGoodsNo') || '订单产品编号',
          field: 'orderGoodsNo',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('goods_label_identifyGoodsNo') || '识别编号',
          field: 'identifyGoodsNo',
          headerAlign: 'center',
          align: 'left',
          width: 230,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('goods_label_orderGoodsName') || '订单产品名称',
          field: 'orderGoodsDisplayName',
          headerAlign: 'center',
          align: 'left',
          width: 380,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('goods_label_qty') || '数量',
          field: 'qty',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('goods_label_inPackageQty') || '装箱入数',
          field: 'inPackageQty',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('goods_label_boxQty') || '箱数',
          field: 'boxQty',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
    }
  },
}
</script>
